import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";

const reportData = [
  { title: "Employee Attendance ", path: '/employeeAttendanceByMonth' },
  { title: "Dormitory Details ", path: '/dormitoryByUser' },
  { title: "Employee Pay Details ", path: '/employeePayDetailsDateRange' },
  { title: "Employee Payslip Report ", path: '/payslip' },
  { title: "Employee Paysheet Report ", path: '/employeePaySheetReport' },
  { title: "Employee Advance Report ", path: '/employeeAdavanceByDate' },
  { title: "Truck Trip Report ", path: '/truckTripReport' },
  { title: "Team Member Details ", path: '/teamMemberDetails'}
]
const Reports = () => {
  const navigate  = useNavigate();
  return (
    <div className="d-flex">
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Reports"
          showButtons={true}
        />
        <h4 className="mb-4 text-center fw-bold">
          Reports Menu
        </h4>
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {reportData.map((report, i) => (
            <Col key={i}>
              <Card className="h-150 shadow border-0 text-center"
                style={{ height: '200px', cursor: 'pointer', transition: '0.3s ease-in-out' }}
                onClick={() => navigate(report.path)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                onMouseLeave={(e)=> (e.currentTarget.style.transform = 'scale(1)')}
              >
                <Card.Body className="d-flex justify-content-center align-items-center">
                  <Card.Title className="fs-4 fw-semibold">
                    {report.title}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
};

export default Reports;